(() => {
  for (const item of document.querySelectorAll(".js-request-label")) {
    const inputEl = item.querySelector("input")
    const textEl = item.querySelector(".js-request-placeholder")

    if (inputEl.value === "") {
      textEl.classList.remove("filled")
      textEl.classList.add("no-filled")
    } else {
      textEl.classList.remove("no-filled")
      textEl.classList.add("filled")
    }

    inputEl.addEventListener("focus", () => textEl.classList.add("filled"))
    inputEl.addEventListener("blur", () => !inputEl.value && textEl.classList.remove("filled"))
    inputEl.addEventListener("blur", () => !inputEl.value && textEl.classList.add("no-filled"))
  }
})()



// WEBPACK FOOTER //
// ./src/blocks/form/form.js